import { shoeConventionForSite } from "@config/site/site-config";
import type { IPartFilter } from "@contentful-api/types/contentful";
import { FilterTypes } from "@lib/constants/filtersConstants";

export const getAdditionalSizesFilters = (listOfFilters: IPartFilter[]) => {
    if (listOfFilters?.some((it) => it.fields.filterType === FilterTypes.size)) {
        return shoeConventionForSite.map(
            (it) =>
                ({
                    fields: {
                        filterName: `Size.${it}`,
                        isToolbar: false,
                        isDialog: false,
                        facetName: `fullSizes.${it.toLowerCase()}`,
                        filterType: "size",
                    },
                }) as IPartFilter
        );
    } else {
        return [];
    }
};
